import { render, staticRenderFns } from "./DormTabNavBranch.vue?vue&type=template&id=4dfa03ce&scoped=true&"
import script from "./DormTabNavBranch.vue?vue&type=script&lang=js&"
export * from "./DormTabNavBranch.vue?vue&type=script&lang=js&"
import style0 from "./DormTabNavBranch.vue?vue&type=style&index=0&id=4dfa03ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa03ce",
  null
  
)

component.options.__file = "DormTabNavBranch.vue"
export default component.exports